import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { SvgSourceHorseTrailer, SvgSourceCargoTrailer, SvgSourceTruck, SvgSourcePart, SvgSourceInventory } from "../Utils/Icons.js";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import {Settings} from '../Utils/Settings.js';

const styles = theme => ({
    buttonSelector: {
        margin: "5px auto",
        display: "block"
    },
    svgIcon: {
        verticalAlign: "middle",
        marginRight: "10px"
    }
});

class PrimaryInventorySelector extends Component {
    render() {
        const classes = this.props.classes;
        return (
            <Grid container spacing={24}>
                {Settings.showTrailers &&
                <Grid key="trailers" item sm={6} xs={12}>
                    <Link style={{textDecoration: "none", color: "#FFF"}} to="/search/horse-trailers?pn=1">
                        <Button style={{width: "250px"}} className={classes.buttonSelector} variant="contained" size="large" color="primary">
                            <SvgSourceHorseTrailer height={32} width={32} className={classes.svgIcon}/> Horse Trailers
                        </Button>
                    </Link>
                </Grid>}
                {Settings.showCargo &&
                <Grid key="cargo" item sm={6} xs={12}>
                    <Link style={{textDecoration: "none", color: "#FFF"}} to="/search/cargo-trailers?pn=1">
                        <Button style={{width: "250px"}} className={classes.buttonSelector} variant="contained" size="large" color="primary">
                            <SvgSourceCargoTrailer height={32} width={32} className={classes.svgIcon}/> Cargo Trailers
                        </Button>
                    </Link>
                </Grid>}
                {Settings.showTrucks &&
                <Grid key="trucks" item sm={6} xs={12}>
                    <Link style={{textDecoration: "none", color: "#FFF"}} to="/search/trucks?pn=1">
                        <Button style={{width: "250px"}} className={classes.buttonSelector} variant="contained" size="large" color="primary">
                            <SvgSourceTruck height={32} width={32} className={classes.svgIcon}/> Trucks
                        </Button>
                    </Link>
                </Grid>}

                {Settings.showParts &&
                <Grid key="parts"  sm={6} xs={12}>
                    <Link style={{textDecoration: "none", color: "#FFF"}} to="/search/parts?pn=1">
                        <Button style={{width: "250px"}} className={classes.buttonSelector} variant="contained" size="large" color="primary">
                            <SvgSourcePart height={24} width={24} className={classes.svgIcon}/> Parts
                        </Button>
                    </Link>
                </Grid>}

                {Settings.showInventory &&
                <Grid key="inventory" item sm={6} xs={12}>
                    <Link style={{textDecoration: "none", color: "#FFF"}} to="/inventory">
                        <Button style={{width: "250px"}} className={classes.buttonSelector} variant="contained" size="large" color="primary">
                            <SvgSourceInventory height={24} width={24} className={classes.svgIcon}/> Inventory
                        </Button>
                    </Link>
                </Grid>}
            </Grid>);
    }
}

export default withStyles(styles)(PrimaryInventorySelector);

